
import { PublicationProfileCardModel } from '../models/PublicationProfileCardModel.js';
import { PublicationProfileCardView } from '../views/PublicationProfileCardView.js';

export class PublicationProfileCardController {
    constructor() {

        this.model = new PublicationProfileCardModel();
        this.view = new PublicationProfileCardView();

        this.model.subscribe(state => this.view.render(state));
    }
}